export default __webpack_public_path__ + "./images/sw.5dfe6815.png";